var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-question-by-product-codes"},[_c('i-tree',{attrs:{"data":_vm.questionTreeData,"expand-node":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }